import { AccountInfo, IPublicClientApplication } from "@azure/msal-browser";
import { Chart } from "../../components/ViewConfig/ConfigProvider";
import { getConfigurl, buildRheoURL, getRheoApiUrl, getRheoServerUrl } from "../../Config/config";


export interface FetchAction{
    type:'GetUserSkids'|'GetSkidData'
    params:params
    url:string
}
type params = Record<string, string>|string[][]|URLSearchParams
export interface TokenRequest{
    scopes:string[],
    account:AccountInfo
}
export interface DataParams{
    timeDelta:number,
    skid:string
}
export interface UserSkidsParams{
    email:string
}
 
interface Options{
    method:"GET",
    headers:Headers
}
const baseConfigURL =getConfigurl()
function buildRheoAPIOptions(token:string):Options{
    const headers = new Headers();
    headers.append("Authorization","Bearer "+token)
    console.log(token)
    const options:Options = {
        method:"GET",
        headers: headers
    }
    return options
}
function buildOptions(token:string):Options{
    const headers = new Headers();
    headers.append("Authorization",token)
    console.log(token)
    const options:Options = {
        method:"GET",
        headers: headers
    }
    return options

}
function buildParams(params:params):URLSearchParams{
    const searchParams = new URLSearchParams(
        params
    )
    return searchParams
}



export async function authenticatedFetch(request:TokenRequest,instance:IPublicClientApplication,params:params, urlString:string):Promise<Response>{
    
     return instance.acquireTokenSilent(request).then((response)=>{
        const options = buildOptions(response.accessToken)
        const url = new URL(urlString)
        url.search = buildParams(params).toString()
         return fetch(url, options)
    })
}
export async function authenticatedRheoAPIFetch(request:TokenRequest,instance:IPublicClientApplication,params:params, urlString:string):Promise<Response>{
    
     return instance.acquireTokenSilent(request).then((response)=>{
        const options = buildRheoAPIOptions(response.accessToken)
        const url = new URL(urlString)
        url.search = buildParams(params).toString()
         return fetch(url, options)
    })
}
export async function fetchViews(request:TokenRequest,instance:IPublicClientApplication, skid:string):Promise<Response>{
    const params = {
        'Skid':skid
    }
    const url = baseConfigURL+'/GetSkidViews'
    return authenticatedFetch(request, instance, params, url)
}
export async function fetchDeafultView(request:TokenRequest,instance:IPublicClientApplication, skid:string):Promise<Response>{
    const params = {
        'Skid':skid
    }
    const url = baseConfigURL+'/GetDefaultSkidView'
    return authenticatedFetch(request, instance, params, url)
}

export async function fetchViewConfig(request:TokenRequest,instance:IPublicClientApplication, skid:string, view:string):Promise<Response>{
    const params = {
        'Skid':skid,
        'View':view
    }
    const url = baseConfigURL+'/SwitchView'
    return authenticatedFetch(request, instance, params, url)
}
export async function fetchAvailableSkids(request:TokenRequest,instance:IPublicClientApplication):Promise<Response>{
    const params = {}
    const url = baseConfigURL+'/GetAvailableSkids'
    return authenticatedFetch(request, instance, params, url)
}
export async function fetchAvailableSkidsWithConfig(request:TokenRequest,instance:IPublicClientApplication):Promise<Response>{
    const params = {}
    const url = baseConfigURL+'/GetAvailableSkidsWithConfig'
    return authenticatedFetch(request, instance, params, url)
}
export async function fetchAvailableSkidsWithConfigHeaders(request:TokenRequest,instance:IPublicClientApplication):Promise<Response>{
     const params = {}
    const url = baseConfigURL+'/GetUserSkidsWithHeaders'
    return authenticatedFetch(request, instance, params, url)
}
export async function fetchWStoken(request:TokenRequest,instance:IPublicClientApplication, skid:string){
    console.log("fetching ws token for skid:",skid)
    const params = {
        'skid':skid
    }
    const url = getRheoApiUrl()+'/token'
    console.log("using url:",url)
    return authenticatedRheoAPIFetch(request, instance, params, url)
}
export async function getToken(skid:string, instanceToken:string){
    //const url = new URL("https://rheo-api.azurewebsites.net/token")
    //const url = new URL("http://localhost:8000/token");
    const url = buildRheoURL("/token")
    const headers = new Headers();
    headers.append("Authorization", "Bearer " + instanceToken); 
    const options = {
        method: "GET",
        headers: headers
      };
      const search = new URLSearchParams({
       skid: skid
     });
      url.search = search.toString()
     fetch(url, options).then(res=>res.json()).then((body)=>{      
        return body.token
     })
    }

export interface DataOptions{
    start: number,
    end: number,
    skid: string,
    view: Map<string, Chart>,
    aggregation: number
}
export interface ExplorerOptions{
    start: number,
    end: number,
    skid: string,
    view: Map<string, Chart>,
   
}
function buildDataParams(options:DataOptions):URLSearchParams{
 const searchParams = new URLSearchParams(
    {
        'Skid': options.skid,
        'Aggr': `${options.aggregation}`,
        'Start': new Date(options.start).toISOString().slice(0, -1),
        'End': new Date(options.end).toISOString().slice(0, -1),
    }
 )
    console.log('Search params so far:',searchParams.toString())
    options.view.forEach(chart =>{
        chart.categories.forEach(category => {
            searchParams.append('Tags', category.datakey)
        });
    })
 return searchParams
}
function buildExplorerParams(options:ExplorerOptions):URLSearchParams{
    const searchParams = new URLSearchParams(
    {
        'skid': options.skid,
        'start': new Date(options.start).toISOString().slice(0, -1),
        'end': new Date(options.end).toISOString().slice(0, -1),
    }
 )
    console.log('Search params so far:',searchParams.toString())
    options.view.forEach(chart =>{
        chart.categories.forEach(category => {
            searchParams.append('tags', category.datakey)
        });
    })
    return searchParams
}
export async function fetchData(request:TokenRequest,instance:IPublicClientApplication, options:DataOptions):Promise<Response>{
    const params = buildDataParams(options) 
    const url = baseConfigURL+'/GetData'
    return authenticatedFetch(request, instance, params, url)
}
export async function fetchFromExplorer(request:TokenRequest,instance:IPublicClientApplication, options:ExplorerOptions):Promise<Response>{
    const params = buildExplorerParams(options)
    const url = baseConfigURL+'/explorer'
    return authenticatedFetch(request, instance, params, url)
}
export interface ReportOptions{
    start: number,
    end: number,
    skid: string,
    resample_rate: number,
    emailStatus: boolean,
    emails:Set<string>,
    length:number
    
}
function buildReportParams(options:ReportOptions):URLSearchParams{
    const searchParams = new URLSearchParams({
        'start': new Date(options.start).toISOString(),
        'end': new Date(options.end).toISOString(),
        'emailStatus':`${options.emailStatus}`,
        'resample_rate':`${options.resample_rate}`,
        'skid':options.skid,
        'length':`${options.length}`
    })
    options.emails.forEach(email=>{
        searchParams.append('emails',email)
    })
    return searchParams
}
export async function fetchReport(request:TokenRequest,instance:IPublicClientApplication, options:ReportOptions){
    const params = buildReportParams(options)
    const url = baseConfigURL+'/SendReport'
    return authenticatedFetch(request, instance, params, url)
}
export async function fetchBaseline(request:TokenRequest,instance:IPublicClientApplication, skid:string, tag:string):Promise<Response>{
    const params = {
        'Skid':skid,
        'Tag':tag
    }
    const base = getRheoServerUrl()
    const url = base+'/getbaseline'
    return authenticatedFetch(request, instance, params, url)
}
export async function fetchBaselines(request:TokenRequest,instance:IPublicClientApplication, skid:string):Promise<Response>{
    const params = {
        'Skid':skid,
    }
    //const base = 'https://rheoadvise.wittystone-a146b357.norwayeast.azurecontainerapps.io'
    const base = getRheoServerUrl()
    const url = base+'/getbaselines'
    return authenticatedFetch(request, instance, params, url)
}
export async function fetchTresholds(request:TokenRequest,instance:IPublicClientApplication, skid:string):Promise<Response>{
    const params = {
        'Skid':skid,
        'Action':'getTresholds'

    }
    //const base = 'https://rheoadvise.wittystone-a146b357.norwayeast.azurecontainerapps.io'
    const base = getRheoServerUrl()
    const url = base+'/rheoadvise'
    return authenticatedFetch(request, instance, params, url)
}